import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProjectFilesTreeModule } from '@portal-core/project-files/components/project-files-tree/project-files-tree.module';
import { PopupModule } from '@portal-core/ui/popup/popup.module';
import { WorkspaceTreeModule } from '@portal-core/workspaces/directives/workspace-tree/workspace-tree.module';
import { ProjectFilePathInputComponent } from './project-file-path-input.component';

@NgModule({
  declarations: [
    ProjectFilePathInputComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    ProjectFilesTreeModule,
    WorkspaceTreeModule,
    PopupModule,
    ReactiveFormsModule
  ],
  exports: [
    ProjectFilePathInputComponent
  ]
})
export class ProjectFilePathInputModule { }
